import React, { FC } from 'react';
import { ToggleButtonGroup } from '@dev/ee-components';
import styled from 'styled-components';

import {
    ToggleButtonProps,
    GeographyToggleBtnOptInterface,
    GeographyToggleBtnValues,
} from '../CampaignReportGeographyInterface';

const ToggleButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    background-color: inherit;
    margin-bottom: 24px;
`;

const ToggleButtons: FC<ToggleButtonProps> = (props: ToggleButtonProps): JSX.Element => {
    const { setCountryStaticticsFormat } = props;
    const toggleBtnOptions: GeographyToggleBtnOptInterface[] = [
        {
            label: '#',
            value: GeographyToggleBtnValues.Number,
        },
        {
            label: '%',
            value: GeographyToggleBtnValues.Percent,
        },
    ];

    const handleChangeToggleButton = (format): void => {
        setCountryStaticticsFormat(format);
    };

    return (
        <ToggleButtonWrapper>
            <ToggleButtonGroup
                defaultValue={GeographyToggleBtnValues.Number}
                size="small"
                options={toggleBtnOptions}
                onChange={(newValue) => handleChangeToggleButton(newValue)}
            />
        </ToggleButtonWrapper>
    );
};

export default ToggleButtons;
